import { UserSkill } from "./skill";

export interface User {
	id: string;

	email: string;
	name: string;

	[key: string]: any;
}
export interface PagedUserResponse {
	totalCount: number;
	items: UserRights[];
}

export interface UserRights {
	id: string;
	userName: string;
	email: string;
	name: string;
	jobTitle: string;
	department: string;
	type: UserType;
	isActive: boolean;
	isAdmin: boolean;
	isFromAdminGroup: boolean;
	isSupervisor: boolean;
	hasOutboundRights: boolean;
	hasOperatorRights: boolean;
	licenseType: LicenseType;
	[key: string]: any;
	userSkills?: UserSkill[];
	isMemberedOnOmniQueues?: boolean;
	graphLicenseStatus?: GraphLicenseStatus;
}

export interface UserRightsChanged {
	id: string;
	isActive: boolean;
	isAdmin: boolean;
	isSupervisor: boolean;
	hasOutboundRights: boolean;
	hasOperatorRights: boolean;
	name: string;
	licenseType: LicenseType;
	[key: string]: any;
	userName: string;
}

export enum UserType {
	Database = 0,
	AzureActiveDirectory = 1,
	Office365 = 2,
}

export interface AppUser {
	id: string;
	tenantId: string;
	userName: string;
	name: string;
	surname: string;
	email: string;
	emailConfirmed: boolean;
	phoneNumber: string;
	phoneNumberConfirmed: boolean;
	displayName: string;
	jobTitle: string;
	department: string;
	type: UserType;
	isActive: boolean;
	isAdmin: boolean;
	isSupervisor: boolean;
	hasOutboundRights: boolean;
}

export interface AuthorizedUser {
	userData: AppUser;
	tenantId: string;
	tenantName: string;
	token: string;
}

export enum LicenseType {
	ProVoice = 0,
	ProOmni = 1,
	ProOmniPremium = 2,
	AiOmni = 3,
}

export class UserLicense {
	id!: string;
	initialLicense?: LicenseType;
	newLicense?: LicenseType;
}

export interface UserDto {
	id: string;
	name: string;
	userSkills: UserSkill[];
	hasOperatorRights: boolean;
	hasParkingRight: boolean;
	hasAllInteractionVisibilityRight: boolean;
	hasAgentsActivityRight: boolean;
	tenantId?: string;
	isFromAdminGroup?: boolean;
	hasPowerBIContributorAccess: boolean;
	hasPowerBIViewerAccess: boolean;
	graphLicenseStatus?: GraphLicenseStatus;
	assignedLicenses?: GraphSubscribedSku[];
}

export interface GraphSubscribedSku {
	productName: string;
	graphLicenseStatus: GraphLicenseStatus;
}

export interface LoginRequest {
	token: string;
	target: string;
	userTenantId: string;
	azureTenantId: string;
}

export interface TenantLicensesValidationResult {
	isLicenseLimitPassed: boolean;
	licenseValidationResults?: UserLimitValidationResult[];
	allUsersHaveOmniLicense: boolean;
	allUsersHaveSupervisorLicense: boolean;
	allUsersHaveOperatorLicense: boolean;
}

export enum LimitedUserType {
    Pro = 0,
    ProOmni = 1,
    ProPremium = 2,
    Supervisors = 3,
    SupervisorsPremium = 4,
    Operators = 5,
    OperatorsPremium = 6,
    AgentsAiOmni = 7,
}

export interface UserLimitValidationResult {
	limitedUserType: LimitedUserType;
	allowedNumberOfUsers: number;
	attemptedNumberOfUsers: number;
}

export enum GraphLicenseStatus {
	Valid,
	Missing,
	Suspended,
	Expired,
	ExpiringSoon,
}
